<template>
  <div>
    <v-dialog v-model="dialog" max-width="880" persistent scrollable>
      <v-card class="mcg-card">
        <v-card-title class="mcg-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="teal darken-3">mdi-check-decagram-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">
                {{ datos.esEdicion ? 'Confirmar edición del programa' : 'Confirmar registro del programa' }}
              </div>
              <div class="text-body-2 white--text">
                <span v-if="datos.esEdicion">
                  <v-chip x-small color="amber darken-2" dark label class="mr-1">Editando</v-chip>
                  ID {{ datos.programa_id }} · Revisa los cambios antes de guardar
                </span>
                <span v-else>Revisa los datos antes de guardar</span>
              </div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pt-4 pb-2">

          <!-- Datos generales -->
          <div class="mcg-section-label">Datos generales</div>
          <v-card outlined class="pa-3 mb-3">
            <div class="mcg-nombre mb-2">{{ datos.nombre_compuesto }}</div>
            <v-row dense>
              <v-col cols="6" sm="3"><div class="mcg-key">Sede</div><div class="mcg-val">{{ datos.sedeNombre }}</div></v-col>
              <v-col cols="6" sm="3"><div class="mcg-key">Modalidad</div><div class="mcg-val">{{ datos.modalidad }}</div></v-col>
              <v-col cols="6" sm="3"><div class="mcg-key">Gestión</div><div class="mcg-val">{{ datos.gestion }}</div></v-col>
              <v-col cols="6" sm="3"><div class="mcg-key">Versión / Grupo</div><div class="mcg-val">{{ datos.version }} / {{ datos.grupo }}</div></v-col>
              <v-col cols="6" sm="3"><div class="mcg-key">Nota mínima</div><div class="mcg-val">{{ datos.nota_aprobacion }}</div></v-col>
              <v-col cols="6" sm="3"><div class="mcg-key">Inicio matrícula</div><div class="mcg-val">{{ datos.fecha_matricula }}</div></v-col>
              <v-col cols="6" sm="3"><div class="mcg-key">Inicio programa</div><div class="mcg-val">{{ datos.fecha_inicio }}</div></v-col>
              <v-col cols="6" sm="3" v-if="datos.fecha_fin"><div class="mcg-key">Fin programa</div><div class="mcg-val">{{ datos.fecha_fin }}</div></v-col>
            </v-row>
            <v-row dense class="mt-1" v-if="datos.coordinador || datos.responsable || datos.universidad || datos.sucursal">
              <v-col cols="12" sm="4" v-if="datos.coordinador"><div class="mcg-key">Coordinador de Mkt</div><div class="mcg-val">{{ datos.coordinador }}</div></v-col>
              <v-col cols="12" sm="4" v-if="datos.responsable"><div class="mcg-key">Responsable acad.</div><div class="mcg-val">{{ datos.responsable }}</div></v-col>
              <v-col cols="12" sm="4" v-if="datos.universidad"><div class="mcg-key">Universidad convenio</div><div class="mcg-val">{{ datos.universidad }}</div></v-col>
              <v-col cols="12" v-if="datos.sucursal">
                <div class="mcg-key">Sucursal para factura</div>
                <div class="mcg-val d-flex align-center" style="gap:6px;">
                  <v-icon small color="teal darken-2">mdi-domain</v-icon>
                  {{ datos.sucursal }}
                </div>
              </v-col>
              <v-col cols="12" v-else-if="datos.esEdicion">
                <v-chip x-small color="orange lighten-4" class="orange--text text--darken-3">
                  <v-icon left x-small>mdi-alert-outline</v-icon>
                  Sin sucursal asignada para factura
                </v-chip>
              </v-col>
            </v-row>
          </v-card>

          <!-- Módulos -->
          <div class="mcg-section-label">
            Módulos
            <v-chip x-small color="teal lighten-4" class="teal--text text--darken-3 ml-1">{{ datos.modulos.length }}</v-chip>
          </div>
          <v-simple-table dense class="mcg-table mb-3">
            <thead>
              <tr>
                <th style="width:40px">#</th>
                <th>Nombre</th>
                <th style="width:160px">Tipo calificación</th>
                <th style="width:110px">Inicio</th>
                <th style="width:110px">Fin</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="m in datos.modulos" :key="m.numero">
                <td><v-chip x-small color="teal darken-1" dark label>{{ m.numero }}</v-chip></td>
                <td class="text-body-2">{{ m.nombre }}</td>
                <td class="text-body-2">{{ m.tipo_calificacion }}</td>
                <td class="text-body-2">{{ m.fecha_inicio || '—' }}</td>
                <td class="text-body-2">{{ m.fecha_fin || '—' }}</td>
              </tr>
              <tr v-if="!datos.modulos.length">
                <td colspan="5" class="text-center text--secondary py-2">Sin módulos</td>
              </tr>
            </tbody>
          </v-simple-table>

          <!-- Planes -->
          <div class="mcg-section-label">
            Planes de pago
            <v-chip x-small color="teal lighten-4" class="teal--text text--darken-3 ml-1">{{ datos.planes.length }}</v-chip>
          </div>
          <div v-for="(plan, pi) in datos.planes" :key="pi" class="mcg-plan-block mb-2"
            :style="plan.estado === false ? 'opacity:0.6;border-color:#bdbdbd;' : ''">
            <div class="mcg-plan-header d-flex align-center px-3 py-1" style="gap:8px;"
              :style="plan.estado === false ? 'background:#eeeeee;' : ''">
              <v-chip x-small label :color="plan.estado === false ? '#e0e0e0' : (plan.xauto ? '#B2DFDB' : '#C8E6C9')"
                :text-color="plan.estado === false ? '#757575' : ''">
                {{ plan.xauto ? 'auto' : 'template' }}
              </v-chip>
              <span class="text-body-2 font-weight-medium"
                :style="plan.estado === false ? 'text-decoration:line-through;color:#9e9e9e;' : ''">
                {{ plan.nombre }}
              </span>
              <v-chip v-if="plan.estado === false" x-small color="red lighten-4" class="red--text text--darken-3 ml-1" label>
                <v-icon left x-small>mdi-cancel</v-icon> Inactivo
              </v-chip>
            </div>
            <v-simple-table dense class="mcg-table">
              <thead>
                <tr>
                  <th>Concepto</th>
                  <th style="width:110px">Monto (Bs / $)</th>
                  <th style="width:80px">Cuotas</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(c, ci) in plan.cobros" :key="ci">
                  <td class="text-body-2">{{ c.nombre_concepto }}</td>
                  <td class="text-body-2">{{ c.monto }}</td>
                  <td class="text-body-2">{{ c.cuotas }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div v-if="!datos.planes.length" class="text-center text--secondary py-2 mb-2">Sin planes de pago</div>

        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="cerrar()">
            <v-icon left small>mdi-arrow-left</v-icon> Revisar
          </v-btn>
          <v-btn color="teal darken-1" class="white--text" @click="confirmar()">
            <v-icon left small>mdi-content-save</v-icon> Confirmar y guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      resolvePromise: null,
      datos: {
        esEdicion: false,
        programa_id: null,
        nombre_compuesto: '',
        sedeNombre: '',
        modalidad: '',
        gestion: '',
        version: '',
        grupo: '',
        nota_aprobacion: '',
        fecha_matricula: '',
        fecha_inicio: '',
        fecha_fin: '',
        coordinador: '',
        responsable: '',
        universidad: '',
        sucursal: null,
        modulos: [],
        planes: [],
      },
    };
  },
  methods: {
    openmodal(payload) {
      this.datos = payload;
      this.dialog = true;
      return new Promise(resolve => { this.resolvePromise = resolve; });
    },
    cerrar() {
      if (this.resolvePromise) this.resolvePromise(false);
      this.dialog = false;
    },
    confirmar() {
      if (this.resolvePromise) this.resolvePromise(true);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.mcg-card { border-radius: 14px; overflow: hidden; }
.mcg-hero { background: linear-gradient(120deg, #004D40 0%, #00796B 45%, #4DB6AC 100%); }

.mcg-section-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #00796B;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
}
.mcg-nombre {
  font-size: 1rem;
  font-weight: 600;
  color: #004D40;
}
.mcg-key { font-size: 0.7rem; color: #90a4ae; text-transform: uppercase; letter-spacing: 0.04em; }
.mcg-val { font-size: 0.875rem; color: #263238; font-weight: 500; }

.mcg-table thead tr th {
  background: #E0F2F1 !important;
  color: #004D40 !important;
  font-size: 0.7rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 5px 10px !important;
}
.mcg-table tbody tr td { padding: 4px 10px !important; border-bottom: 1px solid #f0f0f0 !important; }

.mcg-plan-block { border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; }
.mcg-plan-header { background: #f5f5f5; border-bottom: 1px solid #e0e0e0; min-height: 36px; }
</style>
